// The subscription KEY a job ran on, as a small coloured chip — the same
// colour wherever the key appears (its card, a running slot, a recent result,
// a session), so a row is tied to its key at a glance without reading.
// Colour = a stable pick from a small palette by the key's label; the palette
// avoids the amber of kind chips and the purple of the vendor pill.
import React from "react";

const PALETTE = [
  { bg: "#CFFAFE", fg: "#0E7490", dot: "#0E7490" }, // cyan
  { bg: "#EDE9FE", fg: "#6D28D9", dot: "#7C3AED" }, // violet
  { bg: "#DCFCE7", fg: "#15803D", dot: "#16A34A" }, // green
  { bg: "#FCE7F3", fg: "#BE185D", dot: "#DB2777" }, // pink
  { bg: "#DBEAFE", fg: "#1D4ED8", dot: "#2563EB" }, // blue
  { bg: "#FFEDD5", fg: "#C2410C", dot: "#EA580C" }, // orange
];

export function keyColor(label) {
  const s = String(label || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function KeyDot({ label, size = 8, className = "" }) {
  const c = keyColor(label);
  return <span className={`inline-block rounded-full shrink-0 ${className}`} style={{ width: size, height: size, background: c.dot }} aria-hidden="true" />;
}

// `keys` = the labels a job used in order (one, or two after a mid-run
// switch); `label` is the single-key shorthand.
export default function KeyChip({ keys, label, title, testid = "fleet-key-chip" }) {
  const list = Array.isArray(keys) && keys.length ? keys : (label ? [label] : []);
  if (!list.length) return null;
  const first = keyColor(list[0]);
  return (
    <span className="inline-flex items-center gap-1 px-1.5 py-0 rounded-full text-[10.5px] font-medium whitespace-nowrap align-middle"
      style={{ background: first.bg, color: first.fg }} title={title || (list.length > 1 ? `ran on ${list.join(", then ")} (switched mid-run)` : `ran on key ${list[0]}`)}
      data-testid={testid} data-keys={list.join(",")}>
      {list.map((k, i) => (
        <span key={k} className="inline-flex items-center gap-1">
          {i > 0 && <span className="opacity-60">→</span>}
          <KeyDot label={k} size={7} />{k}
        </span>
      ))}
    </span>
  );
}
